import { Box, Button, Flex, Group, Text } from '@mantine/core';
import { IconChartLine, IconExternalLink } from '@tabler/icons-react';
import { Link } from 'react-router';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { ScenarioUpdate } from '../chat/types';

type Props = {
  update: ScenarioUpdate;
};

export function ScenarioUpdateCard({ update }: Props) {
  return (
    <Box bg="orange.1" p="md" style={{ borderRadius: 'var(--mantine-radius-md)' }}>
      <Flex direction="column" gap="sm">
        <Group gap="xs" align="center">
          <IconChartLine size={16} stroke={1.5} color="var(--mantine-color-orange-7)" aria-hidden />
          <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="gray.9">
            {update.headline}
          </Text>
        </Group>
        <Button
          component={Link}
          to={
            update.familyId
              ? `/family/${update.familyId}/cashflows/model/${update.scenarioId}`
              : `/client/${update.clientId}/cashflows/model/${update.scenarioId}`
          }
          variant="filled"
          color="orange"
          size="sm"
          leftSection={<IconExternalLink size={14} />}
          style={{ alignSelf: 'flex-start' }}
        >
          View model
        </Button>
      </Flex>
    </Box>
  );
}
